'use client'

import { createContext, PropsWithChildren, useContext } from 'react'

interface Context {
  companyId?: number
  userId?: number
}

const AddressBookContext = createContext<Context>({} as Context)

type ProviderProps = Context

export const AddressBookContextProvider = ({
  children,
  ...props
}: PropsWithChildren<ProviderProps>) => {
  return <AddressBookContext.Provider value={props}>{children}</AddressBookContext.Provider>
}

export const useAddressBookContext = () => {
  const context = useContext(AddressBookContext)

  if (!context) {
    throw new Error('useAddressBookContext must be used within a AddressBookContextProvider')
  }

  return context
}
